import '@studio/polyfill';
// These use TLA, so we technically have a race condition here, since we're not
// waiting for them to finish exeuting before importing SessionManager
import './bootstrap-i18n';
import './bootstrap-sentry';
import './index.css';

// Anything imported below will execute before the TLAs are finished
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { BUILD_VERSION } from '@studio/api/constants';
import SessionManager from '@studio/core/components/SessionManager';

const LazyApp = lazy(() => import(/* webpackPreload: true */ './App'));

console.info('Build version:', BUILD_VERSION);

const root = createRoot(document.querySelector('#root')!);

root.render(
  <StrictMode>
    <SessionManager>
      <Suspense fallback={null}>
        <LazyApp />
      </Suspense>
    </SessionManager>
  </StrictMode>,
);

// eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.dispose(() => {
    root.unmount();
  });
}
